module.exports = __webpack_public_path__ + "static/media/em-17.57b44b18.png";